import { createFileRoute } from '@tanstack/react-router';

import { PartnerWithUs } from '#features/partners/components/PartnerWithUs';
import { staticPageHead } from '#features/static-pages/utils/head';

const title = 'Partner with Teamplay.gg – Partnerships, Sponsorships & Investment';
const description =
  'Teamplay.gg is open to collaboration. Explore partnerships, sponsorships, and investment opportunities with the LFG platform built for gamers.';

export const Route = createFileRoute('/{-$locale}/_layout/partner-with-us')({
  component: PartnerWithUsPage,
  head: () => staticPageHead({ title, description, pathname: '/partner-with-us' }),
});

function PartnerWithUsPage() {
  return <PartnerWithUs />;
}
